/**
*!/usr/bin/env node
* -*- coding: utf-8 -*-
* Adewale Joshua Portfolio (AJP)
*/


/**
* author: OTechCup
* copyright: &copy; 2022 - new Date().getFullYear() All Rights Reserved | Exfac
* credits: ["Mr. O"]
* version: v0.1.0
* maintainer: OTechCup
* email: support@exfac.info
*/


// import modules
import React from "react";
import { BrowserRouter } from "react-router-dom";

import App from "./App.jsx";


function InitRoutes() {
    return (
        <BrowserRouter>
            <App />
        </BrowserRouter>
    );
};


export default InitRoutes;
